export default "__VITE_ASSET__3NIXkhUB__"